import { render, staticRenderFns } from "./VerifyOtp.vue?vue&type=template&id=4eff9018"
import script from "./VerifyOtp.vue?vue&type=script&lang=js"
export * from "./VerifyOtp.vue?vue&type=script&lang=js"
import style0 from "./VerifyOtp.vue?vue&type=style&index=0&id=4eff9018&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports